import { render, staticRenderFns } from "./InspectionAppraisers.vue?vue&type=template&id=0fcf1413&scoped=true"
import script from "./InspectionAppraisers.vue?vue&type=script&lang=ts"
export * from "./InspectionAppraisers.vue?vue&type=script&lang=ts"
import style0 from "./InspectionAppraisers.vue?vue&type=style&index=0&id=0fcf1413&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcf1413",
  null
  
)

export default component.exports